import type { IVoteOptimizationStrategy, VoteAllocation, VoteOptimizationInput } from "../vote-optimization-strategy"
import { calculateOptimalDistribution } from "../vote-optimization"
import { STRATEGY_ICON } from "../vote-optimization-strategy-factory"

/**
 * Safe strategy: Distributes votes across 5-10 pools to balance earnings with vote dilution risk
 */
export class SafeVoteOptimizationStrategy implements IVoteOptimizationStrategy {
  calculateDistribution(input: VoteOptimizationInput): Array<VoteAllocation> | null {
    const distribution = calculateOptimalDistribution(input.gaugeBribes, input.selectedVotePower, false)
    return distribution
  }

  getName(): string {
    return "Safe"
  }

  getDescription(): string {
    return "Distributes votes across 5/10 pools to balance earnings with vote dilution risk."
  }

  getIcon() {
    return STRATEGY_ICON.SHIELD
  }
}
